<template>
  <div class="welfare-container">
    <div class="welfare-container_ cen">
      <Breadcrumb>
        <BreadcrumbItem to="/">首页</BreadcrumbItem>
        <BreadcrumbItem :to="{ path: '/about', query: { cid: fid } }">关于金色年华</BreadcrumbItem>
        <BreadcrumbItem>{{currentClassName}}</BreadcrumbItem>
      </Breadcrumb>
      <div class="inside-main">
        <div class="welfare-list">
          <div class="welfare-li" v-for="(item, index) in list" :key="index">
            <div class="welfare-li-img" v-if="item.picurl"><div :style="'backgroundImage:url(' + domainNameH5 + '/' + item.picurl + ')'"></div></div>
            <div class="welfare-li-ul">
              <div class="welfare-li-li">
                <div class="item">捐赠人(单位/个人）：</div>
                <div class="cont">{{item.title}}</div>
              </div>
              <div class="welfare-li-li">
                <div class="item">捐赠时间：</div>
                <div class="cont">{{item.author}}</div>
              </div>
              <div class="welfare-li-li">
                <div class="item">捐赠对象：</div>
                <div class="cont">{{item.linkurl}}</div>
              </div>
              <div class="welfare-li-li">
                <div class="item">捐赠内容：</div>
                <div class="cont">{{item.description}}</div>
              </div>
            </div>
          </div>
          <div class="list-page clear" v-if="totalsPage>1">
            <Page
              :current="page"
              :total="totals"
              @on-change="changePage"
              :page-size="5"
              prev-text="上一页"
              next-text="下一页"
            />
            <div class="list-page-total">共{{totalsPage}}页</div>
            <div class="list-page-jump">
              到第 <Input v-model="jumpPage" /> 页
            </div>
            <div class="list-page-btn" @click="jumpPageDeal">确定</div>
          </div>
        </div>
        <div class="inside-left-nav">
          <div class="left-nav-head">
            <div class="chname">关于金色年华</div>
            <div class="enname">{{fname.classname_en}}</div>
          </div>
          <div class="left-nav-list">
            <div class="left-nav-li" v-for="item in getsort" :key="item.id">
              <router-link :to="{ path: '/about', query: { cid: item.id } }" class="left-nav-link">
                <div class="chname">{{item.classname}}</div>
                <div class="enname">{{item.classname_en}}</div>
                <span></span>
              </router-link>
            </div>
            <div class="left-nav-li active">
              <router-link to="/publicwelfare" class="left-nav-link">
                <div class="chname">{{publicwelfarename.classname}}</div>
                <div class="enname">{{publicwelfarename.classname_en}}</div>
                <span></span>
              </router-link>
            </div>
            <div class="left-nav-li">
              <router-link to="/seniorclass" class="left-nav-link">
                <div class="chname">{{seniorclassname.classname}}</div>
                <div class="enname">{{seniorclassname.classname_en}}</div>
                <span></span>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { validateInteger } from '../../assets/js/validate.js'
import { getHeaderData, getPublicWelfareBasicData, getPublicWelfareListData } from '../../api/getData.js'
export default {
  name: 'publicWelfare',
  data () {
    return {
      headerInfo: {},
      fid: '',
      page: 1,
      jumpPage: '',
      totals: 0,
      totalsPage: 1,
      currentClassName: '',
      fname: {},
      publicwelfarename: {},
      seniorclassname: {},
      getsort: [],
      list: []
    }
  },
  metaInfo () {
    return {
      title: this.headerInfo.title,
      meta: [
        { name: 'generator', content: this.headerInfo.generator },
        { name: 'author', content: this.headerInfo.author },
        { name: 'keywords', content: this.headerInfo.keywords },
        { name: 'description', content: this.headerInfo.description }
      ]
    }
  },
  watch: {
    '$route': function () {
      this.getHeaderInfo()
      this.getPublicWelfareListInfo()
    }
  },
  created () {
    this.getPublicWelfareBasicInfo()
    this.getPublicWelfareListInfo()
  },
  methods: {
    async getHeaderInfo () {
      let postData = { cid: 20 }
      let header = await getHeaderData(postData)
      this.headerInfo = header.header
      this.$store.dispatch('SetActiveMenu', { activeMenu: 'about', activeSendMenu: 'publicwelfare' }).then(() => {}).catch(() => {})
    },
    async getPublicWelfareBasicInfo () {
      let result = await getPublicWelfareBasicData()
      this.fid = result.fid
      this.fname = result.fname
      this.publicwelfarename = result.publicwelfarename
      this.seniorclassname = result.seniorclassname
      this.getsort = result.aboutus
      this.getHeaderInfo()
    },
    async getPublicWelfareListInfo () {
      let postData = {}
      postData.p = this.page
      let result = await getPublicWelfareListData(postData)
      this.totals = result.totalnum
      this.totalsPage = Math.ceil(result.totalnum / 5)
      this.currentClassName = result.cname
      this.list = result.list
    },
    changePage (page) {
      this.page = page
      this.getPublicWelfareListInfo()
    },
    jumpPageDeal () {
      if (!validateInteger(this.jumpPage)) {
        this.message('请输入正整数')
        return false
      }
      if (this.jumpPage > this.totalsPage) {
        this.message('页码不能大于' + this.totalsPage)
        return false
      }
      this.page = parseFloat(this.jumpPage)
      this.getPublicWelfareListInfo()
    },
    message (content) {
      this.$alert(content, '提示', {
        confirmButtonText: '确定',
        callback: action => {}
      })
    }
  }
}
</script>

<style scoped lang="less">
  .inside-main{
    padding-bottom: 230px;
  }
  .welfare-list {
    width: 77.22%;
    padding: 0 0 0 30px;
    .welfare-li{
      margin-top: 40px;
      padding: 22px 0 32px 55px;
      background-color: #ffffff;
      box-shadow: 0px 0px 13px 0px rgba(37, 37, 37, 0.15);
      border-radius: 5px;
      overflow: hidden;
      &:first-child{
        margin-top: 0;
      }
      .welfare-li-img{
        float: left;
        width: 286px;
        height: 286px;
        overflow: hidden;
        div{
          width: 100%;
          height: 100%;
          background-position: center;
          background-repeat: no-repeat;
          background-size: cover;
        }
      }
      .welfare-li-ul{
        overflow: hidden;
        padding: 18px 72px 0 20px;
        .welfare-li-li{
          padding: 15px 40px 2px 0;
          border-bottom: 1px dashed #ff7a3d;
          font-size: 30px;
          line-height: 36px;
          overflow: hidden;
          .item{
            float: left;
            color: #ec6420;
          }
          .cont{
            overflow: hidden;
            color: #333333;
            word-break: break-all;
          }
        }
      }
    }
  }
  @media screen and (max-width: 1580px){
    .inside-main{
      padding-bottom: 195px;
    }
  }
  @media screen and (max-width: 1380px){
    .welfare-list{
      .welfare-li{
        padding: 22px 0 32px 22px;
        .welfare-li-ul{
          padding: 18px 22px 0 20px;
        }
      }
    }
  }
  @media screen and (max-width: 1200px){
    .inside-main{
      padding-bottom: 80px;
    }
    .welfare-list {
      width: 100%;
      padding: 0;
      .welfare-li{
        margin-top: 20px;
        padding: 11px 0 16px;
        border-radius: 3px;
        &:first-child{
          margin-top: 0;
        }
        .welfare-li-img{
          float: none;
          width: 143px;
          height: 143px;
        }
        .welfare-li-ul{
          overflow: hidden;
          padding: 9px 10px;
          .welfare-li-li{
            padding: 7px 20px 1px 0;
            border-bottom: 1px dashed #ff7a3d;
            font-size: 15px;
            line-height: 18px;
          }
        }
      }
    }
  }
</style>
